// test2062
(2062 && 0);
